import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MdArrowBack } from 'react-icons/md';
import axiosInstance from '../../api/axiosInstance';

const GalleryCreate = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    title: '',
    category: 'Events',
  });
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Image is required — must be selected before submitting
    if (!image) {
      alert('⚠️ Please select an image before uploading.');
      return;
    }

    setLoading(true);

    const formDataToSend = new FormData();
    formDataToSend.append('name', formData.title); // backend expects 'name'
    formDataToSend.append('category', formData.category);
    formDataToSend.append('image', image);

    try {
      const response = await axiosInstance.post('/gallery', formDataToSend, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.data.success) {
        navigate('/admin/gallery');
      } else {
        alert(response.data.message || 'Failed to upload image');
      }
    } catch (err) {
      alert(err.response?.data?.message || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <button
        onClick={() => navigate('/admin/gallery')}
        className="flex items-center gap-2 text-gray-600 hover:text-[#008300] mb-4 sm:mb-6"
      >
        <MdArrowBack />
        <span>Back to Gallery</span>
      </button>

      <h1 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-6 sm:mb-8">Upload Image</h1>

      <div className="bg-white rounded-xl shadow-sm p-4 sm:p-6 border border-gray-100">
        <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Title
            </label>
            <input
              type="text"
              name="title"
              value={formData.title}
              onChange={handleChange}
              required
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#008300] focus:border-transparent outline-none text-sm sm:text-base"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Category
            </label>
            <select
              name="category"
              value={formData.category}
              onChange={handleChange}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#008300] focus:border-transparent outline-none text-sm sm:text-base"
            >
              <option value="Events">Events</option>
              <option value="Team">Team</option>
              <option value="Office">Office</option>
              <option value="Projects">Projects</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Image <span className="text-red-500">*</span>
              <span className="text-gray-400 font-normal ml-2 text-xs sm:text-sm">(Required — Please upload an image to continue)</span>
            </label>
            <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 sm:p-6 text-center hover:border-[#008300] transition-colors">
              {preview ? (
                <img
                  src={preview}
                  alt="Preview"
                  className="max-h-48 sm:max-h-64 mx-auto rounded-lg"
                />
              ) : (
                <div>
                  <p className="text-gray-500 mb-2 text-sm sm:text-base">
                    Drag and drop an image, or click to select
                  </p>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleImageChange}
                    className="hidden"
                    id="image-upload"
                  />
                  <label
                    htmlFor="image-upload"
                    className="cursor-pointer text-[#008300] font-medium text-sm sm:text-base"
                  >
                    Choose File
                  </label>
                </div>
              )}
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#008300] text-white py-3 rounded-lg font-semibold hover:bg-[#006600] transition-colors disabled:opacity-50 disabled:cursor-not-allowed text-sm sm:text-base"
          >
            {loading ? 'Uploading...' : 'Upload Image'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default GalleryCreate;
